import React, { Component } from 'react';
import AppContentComponent from '../../../templates/content'
import AppCampaignsCreateDialogComponent from '../../../components/campaigns/components/create/modal'
import { connect } from 'react-redux'
import AppPromotionsFormComponent from './parts/form'
import { api } from "../../../../api/index"
import Toggle from 'material-ui/Toggle';

class AppPromotionsUpdateComponent extends Component {

	constructor( props ) {
		super(props);

		this.state = {
			errors: [],
			showErrorDialog: false,
		};

		this.updatePromotion = this.updatePromotion.bind(this);
	}

	componentDidMount() {
		api.promotions.setPromotion( this.props.match.params.promotion_id );
	}

	updatePromotion = (event) => {
		event.preventDefault();

		return new Promise( ( resolve, reject ) => {
			api.promotions.update().then( ( internalPromotionId ) => {
				api.promotions.setPromotion( internalPromotionId );

				resolve( internalPromotionId );
			}).catch( ( errors ) => {
				reject( errors );
			});

		})
	};

	render() {
		return (
			<AppContentComponent>
				<h1>Promotie bewerken</h1>
				<AppPromotionsFormComponent savePromotion={this.updatePromotion} savePromotionLabel="Promotie opslaan" />
				<AppCampaignsCreateDialogComponent />
			</AppContentComponent>
		)
	}
}

const mapStateToProps = ( state ) => {
	return {
		promotion: state.promotion
	}
};

export default connect(mapStateToProps)(AppPromotionsUpdateComponent);


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/update.js